import { Component } from 'react'
import { Chart } from '@antv/g2'
import dayjs from 'dayjs';

interface IProps {
    q_data: any,
    precision?: number,
    width?: number,
    height?: number,
    constages?: any[]
}

export default class LineChart extends Component<IProps> {

    lineChart: Chart;

    componentDidMount() {
        const chart = new Chart({
            container: this.props.q_data?.id.toString(),
            autoFit: true,
            height: this.props.height || 300,
            width: this.props.width || null,
            padding: [0, 0, 30, 40],
        });
        const data = [...this.props.q_data?.data || []];
        chart.data(data);
        chart.tooltip({
            showCrosshairs: true,
        })
        chart.scale({
            time: {
                type: 'timeCat',
                range: [0.05, 0.95],
                tickCount: 5,
                alias: '时间',
                mask: 'YYYY-MM-DD HH:mm:ss'
            },
            value: {
                range: [0.05, 0.95],
                nice: true,
                formatter: (val: number) => `${val.toFixed(this.props.precision)}`,
                alias: '数值',
                tickCount: 6,
            }
        });
        // 手动调整 y 轴的 offset
        chart.axis('value', {
            label: {
                offset: 5,  // 增加或减少这个值来调整 y 轴标签的位置
            },
        });

        chart.removeInteraction('brush');  // 禁用 brush 交互
        chart.removeInteraction('other-visible');  // 禁用 other-visible 交互

        chart.line()
            .position('time*value')
            .shape('smooth'); // 让折线变平滑

        chart.area()
            .position('time*value')
            .color('l(90) 0:rgba(0, 133, 242, 0.8) 1:rgba(109, 207, 255, 0)')
            .style({ fillOpacity: 1 }); // 确保填充透明度

        this.lineChart = chart;
        chart.render();

        // 添加 resize 监听，确保窗口大小变化时图表重新调整
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        // 组件卸载时移除 resize 监听
        window.removeEventListener('resize', this.handleResize);
    }

    // 处理图表重新调整大小
    handleResize = () => {
        if (this.lineChart) {
            const { width, height } = this.props;
            this.lineChart.changeSize( width || window.innerWidth-1387 || 533, height || 300); // 重新设置图表大小
        }
    };

    componentDidUpdate() {
        if (this.lineChart) {
            const data = [...this.props.q_data?.data || []];
            if (!!this.props.constages && this.props.constages.length > 0 && this.props.q_data.warning_limit && this.props.q_data.is_evaluate) {
                this.props.constages.forEach(item => {
                    if (data.length === 0) return;
                    let start = dayjs(item.start_time).valueOf();
                    let end = dayjs(item.end_time).valueOf();
                    let d_start = data[0].time;
                    let d_end = data[data.length - 1].time;
                    if (end < d_end) return;
                    if (start > d_start) return;
                    if (start < d_start) start = d_start;
                    if (end > d_end) end = d_end;
                    start = data.find(d => d.time >= start).time;
                    end = data.find(d => d.time >= end).time;
                    let id = item.id;
                    let warninglimits = this.props.q_data.warning_limit;
                    let wl = warninglimits.find(w => w.stage_id === id);
                    if (!wl) return;

                    let scale = this.props.q_data.scale || 1;
                    this.lineChart.annotation().line({
                        start: [start, wl.values['t2'] * scale],
                        end: [end, wl.values['t2'] * scale],
                        style: {
                            stroke: '#4fb981',
                            lineWidth: 1,
                            lineDash: [3, 3]
                        },
                    })
                    this.lineChart.annotation().line({
                        start: [start, wl.values['t3'] * scale],
                        end: [end, wl.values['t3'] * scale],
                        style: {
                            stroke: '#efa829',
                            lineWidth: 1,
                            lineDash: [3, 3]
                        },
                    })
                    this.lineChart.annotation().line({
                        start: [start, wl.values['t4'] * scale],
                        end: [end, wl.values['t4'] * scale],
                        style: {
                            stroke: '#f68240',
                            lineWidth: 1,
                            lineDash: [3, 3]
                        },
                    })
                    this.lineChart.annotation().line({
                        start: [start, wl.values['t5'] * scale],
                        end: [end, wl.values['t5'] * scale],
                        style: {
                            stroke: '#e45331',
                            lineWidth: 1,
                            lineDash: [3, 3]
                        },
                    })
                })
            }
            this.lineChart.changeData(data);
        }
    }


    render() {
        if (!this.props.q_data || !this.props.q_data?.id) {
            return null;
        }
        return (
            <div className="line-chart-canvas" id={this.props.q_data?.id.toString()}></div>
        )
    }
}
